import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class FindElementsService {

    treeWalkTextNodes: Function;

    constructor() {
        this._setTreeWalkFunc();
    }

    private _setTreeWalkFunc() {
        this.treeWalkTextNodes = (function() {
            // create closure for constants
            let skipTags = {"SCRIPT": true, "IFRAME": true, "OBJECT": true,
                "EMBED": true, "STYLE": true, "LINK": true, "META": true};
            return function(parent, fn, data) {
                let node = parent.firstChild, nextNode;
                while (node && node != parent) {
                    if (node.nodeType === 3) {
                        if (fn(node, data) === false) {
                            return false ;
                        }
                    }
                    // if element with children and not a skipTag type element, then
                    //     iterate through it's children
                    if (node.nodeType === 1 && node.firstChild && !(node.tagName && skipTags[node.tagName])) {
                        node = node.firstChild;
                    } else  if (node.nextSibling) {
                        node = node.nextSibling;
                    } else {
                        // no child and no nextsibling
                        // find parent that has a nextSibling
                        while ((node = node.parentNode) != parent) {
                            if (node.nextSibling) {
                                node = node.nextSibling;
                                break;
                            }
                        }
                    }
                }
            }
        })();
    }

    findByNodeValueRegExp(parent, template, regExp) {
        // https://stackoverflow.com/questions/20413696/how-to-find-closest-tag-to-inner-text
        let foundNodes = [];
        this.treeWalkTextNodes(parent, function(node, data) {
            // node is the text node
            let found = false;
            let map = template.match(regExp);
            node.nodeValue.replace(regExp, (match) => {
                found = map.indexOf(match) > -1
            });
            if (found) {
                foundNodes.push(node);
            }
        });
        return foundNodes;
    }

}
